import _classCallCheck from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { createStore } from '..';
import { getDisplayName } from '../utils';
export function createConnectedStore(initialState, effects) {
  var Context = React.createContext({
    __MISSING_PROVIDER__: true
  });

  var Container =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Container, _React$Component);

    function Container(props) {
      var _this;

      _classCallCheck(this, Container);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Container).call(this, props)); // Create store definition from initial state

      var state = props.initialState || initialState;
      _this.storeDefinition = createStore(state); // Apply effects?

      var fx = props.effects || effects;

      if (fx) {
        fx(_this.storeDefinition);
      }

      _this.state = {
        storeSnapshot: _this.storeDefinition.getCurrentSnapshot()
      };
      _this.subscription = _this.storeDefinition.onAll().subscribe(function () {
        return _this.setState({
          storeSnapshot: _this.storeDefinition.getCurrentSnapshot()
        });
      });
      return _this;
    }

    _createClass(Container, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.subscription.unsubscribe();
        this.storeDefinition.storeSnapshot = null;
        this.storeDefinition = null;
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(Context.Provider, {
          value: this.state.storeSnapshot
        }, this.props.children);
      }
    }]);

    return Container;
  }(React.Component);

  var Consumer = function Consumer(props) {
    return React.createElement(Context.Consumer, null, function (store) {
      if (!isInitialized(store)) {
        throw Error("[Undux] Component \"".concat(props.displayName, "\" does not seem to be nested in an Undux <Container>. To fix this error, be sure to render the component in the <Container>...</Container> component that you got back from calling createConnectedStore()."));
      }

      return props.children(store);
    });
  };

  function withStore(Component) {
    var displayName = getDisplayName(Component);

    var f = function f(props) {
      return React.createElement(Consumer, {
        displayName: displayName
      }, function (storeSnapshot) {
        return React.createElement(Component, Object.assign({
          store: storeSnapshot
        }, props));
      });
    };

    f.displayName = "withStore(".concat(displayName, ")");
    return f;
  }

  return {
    Container: Container,
    useStore: function useStore() {
      return React.useContext(Context);
    },
    withStore: withStore
  };
}

function isInitialized(store) {
  return !('__MISSING_PROVIDER__' in store);
}